import {authenticationService} from "./authentication.service"

export function jwtHeader(jwtToken) {
	return { headers: {"Authorization": `Bearer ${jwtToken}`} }
}

export function currentUserHeader() {
	const currentUser = authenticationService.currentUserValue
	if (currentUser?.jwtToken) {
		return jwtHeader(currentUser.jwtToken)
	}
	return {}
}